/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EmployeeRole {
  Operator = 'Operator',
  Helper = 'Helper'
}
